import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store.tsx";

export const selectArticleMissingImagePlaceholder = createSelector(
  [(state: RootState) => state.global.salesarea.media_urls],
  (mediaUrls) => {
    return mediaUrls?.extra_settings__article_missing_image_placeholder?.[0] ?? undefined;
  }
);
